import React from "react";

const All = () => {
  return (
    <div>
      <h1>All</h1>
    </div>
  );
};

export default All;
